import { render, staticRenderFns } from "./NxmbSchoolList.vue?vue&type=template&id=440ba7d1&scoped=true&"
import script from "./NxmbSchoolList.vue?vue&type=script&lang=js&"
export * from "./NxmbSchoolList.vue?vue&type=script&lang=js&"
import style0 from "./NxmbSchoolList.vue?vue&type=style&index=0&id=440ba7d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440ba7d1",
  null
  
)

export default component.exports